import React from "react";
import moment from "moment";
import { Navigate, Outlet } from "react-router-dom";

export const Apiurl =()=>{
    // return 'http://198.12.253.79:2312/api'
    return 'https://attendanceapi.elitewebdemo.com/api'
}
// clear storage
export const RemoveUserSession = () => {
    localStorage.clear();
    sessionStorage.clear();
}
// set forgotemail
export const forgotemail = (forgotemail) => {
    localStorage.setItem('forgotemail', forgotemail);
}
// get forgotemail
export const GetForgotemail = () => {
    return localStorage.getItem('forgotemail') || null;
}
// set token
export const Token = (token, rememberMe = true) => {
    if (rememberMe) {
        localStorage.setItem('token', token);
    } else {
        sessionStorage.setItem('token', token);
    }
}
// get token
export const GetToken = () => {
    return (
    localStorage.getItem("token") ||
    sessionStorage.getItem("token")
  );
}
//set Login role
export const SetLoginRole = (value, rememberMe = true) => {
    if (rememberMe) {
        localStorage.setItem('LoginRole', value);
    } else {
        sessionStorage.setItem('LoginRole', value);
    }
}
// get login role
export const GetLoginRole = () => {
    return (
    localStorage.getItem("LoginRole") ||
    sessionStorage.getItem("LoginRole")
  );
}

// Calculate working days excluding weekends and holidays
export const calculateWorkingDays = (startDate, endDate, holidays = [], leaveFromDuration = "Full Day", leaveToDuration = "Full Day") => {
    const start = moment(startDate);
    const end = moment(endDate);
    
    const holidayDates = holidays.map(h => {
        let dateToFormat;
        if (typeof h === 'string') {
            dateToFormat = h;
        } else if (h && typeof h === 'object' && h.FromDate) {
            dateToFormat = h.FromDate;
        } else if (h && typeof h === 'object') {
            // Try to use h directly
            dateToFormat = h;
        } else {
            return null;
        }
        const formatted = moment(dateToFormat).format('YYYY-MM-DD');
        return formatted;
    }).filter(d => d !== null && moment(d, 'YYYY-MM-DD').isValid());
    
    let workingDays = 0;
    let currentDate = start.clone();
    
    // Helper function to get duration multiplier
    const getMultiplier = (duration) => {
        if (duration === "Full Day") return 1;
        if (duration === "Half Day") return 0.5;
        if (duration === "Short Day") return 0.25;
        return 1; // Default to full day
    };
    
    // Special case: if same date
    if (start.isSame(end, 'day')) {
        const dateStr = start.format('YYYY-MM-DD');
        const dayOfWeek = start.day(); // 0 = Sunday, 6 = Saturday
        
        const isHoliday = holidayDates.includes(dateStr);
        
        // Check if it's Sunday
        const isSunday = dayOfWeek === 0;
        
        // Check if it's Saturday (but not 1st Saturday)
        const isFirstSaturdayOfMonth = dayOfWeek === 6 && start.date() <= 7;
        const isRegularSaturday = dayOfWeek === 6 && !isFirstSaturdayOfMonth;
                
        // If it's a holiday or non-working day, return 0
        if (isHoliday || isSunday || isRegularSaturday) {
            return 0;
        }
        
        // Return the multiplier for the same-day leave
        const multiplier = getMultiplier(leaveFromDuration);
        return multiplier;
    }
    
    
    while (currentDate.isSameOrBefore(end)) {
        const dateStr = currentDate.format('YYYY-MM-DD');
        const dayOfWeek = currentDate.day(); // 0 = Sunday, 6 = Saturday
        
        // Check if it's a holiday
        const isHoliday = holidayDates.includes(dateStr);
        
        // Check if it's Sunday
        const isSunday = dayOfWeek === 0;
        
        // Check if it's Saturday (but not 1st Saturday)
        const isFirstSaturdayOfMonth = dayOfWeek === 6 && currentDate.date() <= 7;
        const isRegularSaturday = dayOfWeek === 6 && !isFirstSaturdayOfMonth;
                
        // Skip holidays and non-working days
        if (isHoliday || isSunday || isRegularSaturday) {
            currentDate.add(1, 'day');
            continue;
        }
        
        // This is a working day - Apply duration multipliers for first and last day
        if (currentDate.isSame(start)) {
            const multiplier = getMultiplier(leaveFromDuration);
            workingDays += multiplier;
        } else if (currentDate.isSame(end)) {
            const multiplier = getMultiplier(leaveToDuration);
            workingDays += multiplier;
        } else {
            // Full day for middle dates
            workingDays += 1;
        }
        
        currentDate.add(1, 'day');
    }
    
    const result = Math.round(workingDays * 100) / 100;
    return result;
}

// Helper function to get duration enum value
export const getDurationEnumValue = (durationString) => {
    const durationMap = {
        "Full Day": 0,
        "Half Day": 1,
        "Short Day": 2
    };
    return durationMap[durationString] || 0;
}

// Format NoOfDays to handle decimal values properly
export const formatNoOfDays = (days) => {
    if (!days && days !== 0) return '-';
    const numDays = parseFloat(days);
    if (isNaN(numDays)) return '-';
    // Return the number with up to 2 decimal places, removing trailing zeros
    return parseFloat(numDays.toFixed(2));
}

// export const downloadFile = (fileUrl, fileName) => {
//     try {
//       if (!fileUrl) {
//         console.error("No file URL provided");
//         return;
//       }
      
//       // Extract filename from URL if not provided
//       const urlFileName = fileName || fileUrl.substring(fileUrl.lastIndexOf("/") + 1).split("?")[0];
  
//       const xhr = new XMLHttpRequest();
//       xhr.open('GET', fileUrl, true);
//       xhr.responseType = 'blob';
//       xhr.crossOrigin = 'anonymous';
      
//       xhr.onload = function() {
//         if (xhr.status === 200) {
//           const blob = xhr.response;
//           const blobUrl = window.URL.createObjectURL(blob);
//           const link = document.createElement('a');
//           link.href = blobUrl;
//           link.download = urlFileName;
//           link.style.display = 'none';
//           document.body.appendChild(link);
//           link.click();
//           document.body.removeChild(link);
//           window.URL.revokeObjectURL(blobUrl);
//         }
//       };
      
//       xhr.onerror = function() {
//         console.error("Error downloading file");
//       };
      
//       xhr.send();
//     } catch (error) {
//       console.error("Error in downloadFile:", error);
//     }
// };
export const downloadFile = async (fileUrl, fileName) => {
  try {
    if (!fileUrl) return;

    const response = await fetch(fileUrl);
    const blob = await response.blob();

    const blobUrl = window.URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = blobUrl;
    link.download = fileName || fileUrl.split("/").pop(); // ✅ forces download
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    window.URL.revokeObjectURL(blobUrl);
  } catch (error) {
    console.error("Download failed:", error);
  }
};

// Download multiple files at once (for Aadhaar front and back)
export const downloadMultipleFiles = (fileUrls) => {
    try {
      if (!fileUrls || fileUrls.length === 0) {
        console.error("No file URLs provided");
        return;
      }
      
      fileUrls.forEach(({ url, fileName }, index) => {
        setTimeout(() => {
          downloadFile(url, fileName);
        }, index * 500);
      });
    } catch (error) {
      console.error("Error downloading files:", error);
    }
};

// Validate Aadhaar file upload - max 2 files allowed
export const validateAadhaarFiles = (files) => {
    if (!files || files.length === 0) {
        return { isValid: true, error: null };
    }
    
    if (files.length > 2) {
        return { 
            isValid: false, 
            error: "Maximum 2 files allowed for Aadhaar upload" 
        };
    }
    
    return { isValid: true, error: null };
};

// Get time-based leave restrictions for same day leave applications
// Returns available leave types and their allowed slots based on current time
export const getTimeLevelLeaveRestrictions = (selectedDate) => {
    const today = moment().format('YYYY-MM-DD');
    const isToday = moment(selectedDate).format('YYYY-MM-DD') === today;
    
    if (!isToday) {
        // No restrictions for future dates
        return {
            canApplyFullDay: true,
            canApplyHalfDay: true,
            canApplyShortLeave: true,
            availableHalfDaySlots: [1, 2], // Both slots
            availableShortLeaveSlots: [1, 2, 3, 4], // All slots
            restrictionMessage: null
        };
    }

    // For today, apply time-based restrictions
    const currentTime = moment();
    const time1130AM = moment().set({ hour: 11, minute: 30, second: 0 });
    const time1PM = moment().set({ hour: 13, minute: 0, second: 0 });
    const time2PM = moment().set({ hour: 14, minute: 0, second: 0 });
    const time4PM = moment().set({ hour: 16, minute: 0, second: 0 });

    let restrictions = {
        canApplyFullDay: false,
        canApplyHalfDay: false,
        canApplyShortLeave: false,
        availableHalfDaySlots: [],
        availableShortLeaveSlots: [],
        restrictionMessage: null
    };

    // Before 11:30 AM - Can apply full day, both half day slots, and all short leave slots
    if (currentTime.isBefore(time1130AM)) {
        restrictions = {
            canApplyFullDay: true,
            canApplyHalfDay: true,
            canApplyShortLeave: true,
            availableHalfDaySlots: [1, 2],
            availableShortLeaveSlots: [1, 2, 3, 4],
            restrictionMessage: null
        };
    }
    // 11:30 AM to 4:00 PM - Can apply half day for slot 2 only (2:00 PM - 6:00 PM) and short leave for last 2 slots
    else if (currentTime.isSameOrAfter(time1130AM) && currentTime.isBefore(time4PM)) {
        restrictions = {
            canApplyFullDay: false,
            canApplyHalfDay: true,
            canApplyShortLeave: true,
            availableHalfDaySlots: [2], // Only 2:00 PM - 6:00 PM
            availableShortLeaveSlots: [3, 4], // 2:00 PM - 4:00 PM and 4:00 PM - 6:00 PM
            restrictionMessage: "After 11:30 AM - Only Half Day (Afternoon slot) and Short Leave (last 2 slots) available"
        };
    }
    // After 4:00 PM - Can only apply short leave for slot 4 (4:00 PM - 6:00 PM)
    else if (currentTime.isSameOrAfter(time4PM)) {
        restrictions = {
            canApplyFullDay: false,
            canApplyHalfDay: false,
            canApplyShortLeave: true,
            availableHalfDaySlots: [],
            availableShortLeaveSlots: [4], // Only 4:00 PM - 6:00 PM
            restrictionMessage: "After 4:00 PM - Only Short Leave (4:00 PM - 6:00 PM slot) available"
        };
    }

    return restrictions;
};

export const ProtectedRoute = () => {

  const token =
    localStorage.getItem("token") ||
    sessionStorage.getItem("token");

  if (!token) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
};